import React, { useEffect } from "react";

export default function SmModal({ title, onClose, wide, children, footer }) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="sm-overlay" onClick={onClose}>
      <div className={`sm-modal${wide ? " sm-modal--wide" : ""}`} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="sm-modal__header">
          <h3 className="sm-modal__title">{title}</h3>
          <button type="button" className="sm-modal__close" onClick={onClose}>&times;</button>
        </div>
        <div className="sm-modal__body">{children}</div>
        {footer && <div className="sm-modal__footer">{footer}</div>}
      </div>
    </div>
  );
}

export function ConfirmModal({ title, text, subText, onConfirm, onCancel, confirmLabel = "Ўчириш", danger = true }) {
  return (
    <SmModal
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button type="button" className="sm-btn sm-btn--ghost" onClick={onCancel}>Бекор</button>
          <button type="button" className={`sm-btn ${danger ? "sm-btn--danger" : "sm-btn--primary"}`} onClick={onConfirm}>{confirmLabel}</button>
        </>
      }
    >
      <div className="sm-confirm">
        <div className="sm-confirm__icon">{danger ? "!" : "i"}</div>
        <p className="sm-confirm__text">{text}</p>
        {subText && <p className="sm-confirm__sub">{subText}</p>}
      </div>
    </SmModal>
  );
}
